export const DA: Record<string, string> = {
  Home: "Hjem",
  "Resource Selected": "Valgt ressource",
  "Resources List": "Ressourceliste",
  List: "Liste",
  Resources: "Ressourcer",
  "Find Colleague": "Find kollega",
  Settings: "Indstillinger",
  "Floor Plan": "Etageplan",
  Locations: "Placeringer",
  Categories: "Kategorier",
  "Search resource name...": "Søg efter ressource navn...",
  Calendar: "Kalender",
  "View Details": "Vis detaljer",
  "Add to My Favorites": "Tilføj til Mine Favoritter",
  Remove: "Fjern",
  "Resource calendar": "Ressourcekalender",
  Today: "I dag",
  "Previous month": "Forrige måned",
  "Next month": "Næste måned",
  "Previous year": "Forrige år",
  "Next year": "Næste år",
  Close: "Luk",
  "Field is required.": "Feltet er påkrævet.",
  "Invalid date format.": "Ugyldigt datoformat.",
  S: "Sø",
  M: "Ma",
  T: "Ti",
  W: "On",
  F: "Fr",
  January: "Januar",
  February: "Februar",
  March: "Marts",
  April: "April",
  May: "Maj",
  June: "Juni",
  July: "Juli",
  August: "August",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "December",
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mar",
  Apr: "Apr",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Okt",
  Nov: "Nov",
  Dec: "Dec",
  st: ".",
  nd: ".",
  rd: ".",
  th: ".",
  Sunday: "Søndag",
  Monday: "Mandag",
  Tuesday: "Tirsdag",
  Wednesday: "Onsdag",
  Thursday: "Torsdag",
  Friday: "Fredag",
  Saturday: "Lørdag",
  Sun: "Søn",
  Mon: "Man",
  Tue: "Tir",
  Wed: "Ons",
  Thu: "Tor",
  Fri: "Fre",
  Sat: "Lør",
  Su: "Søn",
  Mo: "Man",
  Tu: "Tir",
  We: "Ons",
  Th: "Tor",
  Fr: "Fre",
  Sa: "Lør",
  PM: "PM",
  AM: "AM",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "Du kan ikke booke denne ressource, fordi din mødeanmodning er i konflikt med ressourcens bookingpolitik.",
  "You need permissions to interact with this resource.":
    "Du har brug for tilladelser til at interagere med denne ressource.",
  Reason: "Årsag",
  "The resource cannot be booked {{day}} days in advanced.":
    "Ressourcen kan ikke bookes {{day}} dage i forvejen.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "Slutdatoen for et tilbagevendende møde kan ikke være mere end {{day}} dage fra i dag.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "Mødedurationen må ikke være længere end {{time}} minutter.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "Mødedurationen må ikke være kortere end {{time}} minutter.",
  "Booking policy": "Bookingpolitik",
  Available: "Tilgængelig",
  Selected: "Valgt",
  Booked: "Booket",
  Closed: "Lukket",
  "Filter Options": "Filtrer muligheder",
  "{{resource}} is deleted": "{{resource}} er slettet.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Denne ressource kan bookes, men eventuelle forekomster med konflikter vil ikke blive booket.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Denne ressource kan bookes på forhånd i højst {{day}} dage, eventuelle forekomster ud over den grænse vil ikke blive booket",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Denne ressource kan bookes, men mødedurationen skal være mindst {{time}} minutter.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Denne ressource kan bookes, men mødedurationen må ikke overstige {{time}} minutter.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Booking af denne ressource kræver godkendelse fra ressourceens delegerede. Din anmodning vil blive videregivet og afventer godkendelse.",
  "Resource Name": "Ressourcens navn",
  Description: "Beskrivelse",
  "Resource Mail": "Ressource e-mail",
  Location: "Placering",
  Capacity: "Kapacitet",
  Language: "Sprog",
  "Select an language": "Vælg et sprog",
  "Date/Time Format": "Dato/tidsformat",
  "First day of the week": "Første dag i ugen",
  "Please select a first day": "Vælg venligst en første dag",
  "Please select a time format": "Vælg venligst et tidsformat",
  "Date Format": "Datoformat",
  "Please select a date format": "Vælg venligst et datoformat",
  "Date Separator": "Dato-separator",
  "Please select a date separator": "Vælg venligst en dato-separator",
  Apply: "Anvend",
  "Default Location": "Standardplacering",
  Clear: "Ryd",
  Help: "Hjælp",
  "Unavailable": "Utilgængelig",
  "No data available": "Ingen data tilgængelig",
  "More": "Mere",
  "Available Floor Plans": "Tilgængelige etageplaner",
  "Default Categories": "Standardkategorier",
  "List more Resources": "Vis flere ressourcer",
  Attendees: "Deltagere",
  "Click on Further information to visit our support site":
    "Klik på Yderligere information for at besøge vores supportsider",
    "New Order": "Ny ordre",
    "Save default categories successfully": "Gem standardkategorierne med succes",
      "Save config date/time successfully": "Gem konfigurationsdato/tid med succes",
      "Save language successfully": "Gem sproget med succes",
      "Save default location successfully": "Gem standardplaceringen med succes",
      "And": "Og",
  "Or": "Eller",
  "Available occurrences of the series": "Tilgængelige forekomster af serien",
  "Conflicting Occurrences": "Konfliktende Forekomster",
  "Availability": "Tilgængelighed",
  "Time Format": "Tidsformat",
  "You do not have permission to book this resource.": "Du har ikke tilladelse til at booke denne ressource.",
"This resource does not allow booking of recurring meetings.": "Denne ressource tillader ikke booking af tilbagevendende møder.",
"You cannot book this resource.": "Du kan ikke booke denne ressource."
};
